import React from "react";
import { SectionData, ComponentRenderProps, renderText } from "./index";

const Title = ({ sectionData, props }: { sectionData: SectionData, props: ComponentRenderProps }): JSX.Element | null => {
    return renderText(sectionData.title || "", "title", {} , props , 'h2') || null;
};

export default Title;
